export enum SafeValue {
    SafeHtml = 'SafeHtml',
    SafeStyle = 'SafeStyle',
    SafeScript = 'SafeScript',
    SafeUrl = 'SafeUrl',
    SafeResourceUrl = 'SafeResourceUrl'
}
